import { createSelector } from 'reselect';
import { getNewStats, total, last, simpleChart, simpleChart2, safeDivide } from '../generalUtils';

const providerId = 'stripe';

const stripeSubscriptionUpgradeCount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_upgrade_count')
);

const stripeSubscriptionUpgradeCountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_upgrade_count')
);

const stripeSubscriptionUpgradeAmount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_upgrade_amount')
);

const stripeSubscriptionUpgradeAmountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_upgrade_amount')
);

const stripeSubscriptionDowngradeCount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_downgrade_count')
);

const stripeSubscriptionDowngradeCountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_downgrade_count')
);

const stripeSubscriptionDowngradeAmount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_downgrade_amount')
);

const stripeSubscriptionDowngradeAmountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_downgrade_amount')
);

const stripeSubscriptionDeletedCount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_deleted_count')
);

const stripeSubscriptionDeletedCountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_deleted_count')
);

const stripeSubscriptionDeletedAmount = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'subscription_deleted_amount')
);

const stripeSubscriptionDeletedAmountChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'subscription_deleted_amount')
);


const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    stripeSubscriptionUpgradeCount,
    stripeSubscriptionUpgradeCountChart,
    stripeSubscriptionUpgradeAmount,
    stripeSubscriptionUpgradeAmountChart,
    stripeSubscriptionDowngradeCount,
    stripeSubscriptionDowngradeCountChart,
    stripeSubscriptionDowngradeAmount,
    stripeSubscriptionDowngradeAmountChart,
    stripeSubscriptionDeletedCount,
    stripeSubscriptionDeletedCountChart,
    stripeSubscriptionDeletedAmount,
    stripeSubscriptionDeletedAmountChart,
  },
};
